import { useEffect, useState } from 'react';
import { api } from '../services/api';
import type { ExperienceListItem } from '../types';

export function useExperienceList() {
  const [data, setData] = useState<ExperienceListItem[] | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .listExperiences()
      .then((list) => !cancelled && setData(list))
      .catch((e) => !cancelled && setError(e))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, error, loading };
}
